import type { CityConfig } from "@/pages/city-template/types";

export const romeNyConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Rome",
  state: "New York",
  stateAbbr: "NY",
  slug: "rome-ny",
  route: "/rome-ny",
  title: "Emergency Passport Rome, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rome, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Rome, Griffiss Airport travelers, Oneida County, and Mohawk Valley communities.",
  h1: "Emergency & Expedited Passport Services in Rome, NY",
  heroSubtitle: "Griffiss International Airport is right here in Rome — a former Strategic Air Command base turned drone testing hub and aviation center. Fort Stanwix stands at the heart of the Erie Canal corridor. Syracuse Hancock is 50 miles away. The Mohawk Valley's defense, aviation, and heritage profile creates passport urgency unlike anywhere else — and we help Rome residents, from Griffiss tech workers to Oneida County families to Erie Canal heritage travelers, get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Rome%20New%20York%20with%20historic%20Fort%20Stanwix%20National%20Monument%20in%20the%20foreground%2C%20Erie%20Canal%20corridor%20winding%20through%20the%20Mohawk%20Valley%2C%20Griffiss%20International%20Airport%20complex%2C%20charming%20downtown%20with%20brick%20buildings%20and%20the%20copper%20city%20heritage%2C%20rolling%20green%20hills%20in%20warm%20golden%20afternoon%20light%2C%20professional%20landscape%20photography%20with%20rich%20detail%2C%20no%20text%20overlay&width=1800&height=700&seq=rome-ny-hero-2026&orientation=landscape",
  heroImageAlt: "Rome New York with Fort Stanwix National Monument and Griffiss International Airport",
  geoPosition: "43.2128;-75.4557",
  geoPlacename: "Rome, New York",
  lastModified: "2026-06-11",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~240 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Rome", zips: "13440, 13441, 13442, 13449" },
    { name: "Utica", zips: "13501, 13502, 13503, 13504, 13505" },
    { name: "New Hartford", zips: "13413, 13414, 13420" },
    { name: "Whitesboro", zips: "13492" },
    { name: "Yorkville", zips: "13495" },
    { name: "Marcy", zips: "13403" },
    { name: "Oriskany", zips: "13424" },
    { name: "Oneida", zips: "13421" },
    { name: "Vernon", zips: "13476" },
    { name: "Sherrill", zips: "13461" },
    { name: "Camden", zips: "13316" },
    { name: "Ilion", zips: "13357" },
    { name: "Herkimer", zips: "13350" },
    { name: "Clinton", zips: "13323" },
    { name: "Syracuse", zips: "13201-13252" },
    { name: "Albany", zips: "12201-12250" },
    { name: "Schenectady", zips: "12301-12309" },
    { name: "Buffalo", zips: "14201-14228" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing for Central New York", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Rome-area travelers with immediate departures from SYR, ALB, or Griffiss." },
    { icon: "ri-flight-takeoff-line", title: "Griffiss International Airport & Aviation Hub", desc: "Griffiss International Airport (RME) — a former Strategic Air Command base — is now a drone testing hub, aviation technology center, and Oneida County's aviation anchor." },
    { icon: "ri-building-2-line", title: "Defense & Technology Corridor", desc: "Rome Lab (Air Force Research Laboratory), drone testing at Griffiss, and the Mohawk Valley's defense contracting community create specialized international travel needs with short timelines." },
    { icon: "ri-landscape-line", title: "Erie Canal & Fort Stanwix Heritage", desc: "The Erie Canal's eastern gateway, Fort Stanwix National Monument, and the historic Copper City — Rome's heritage drives its global connections through tourism and cultural exchange." },
  ],
  internalLinks: [
    { name: "Fast passport services in Syracuse, NY", route: "/syracuse" },
    { name: "Expedited passport in Utica, NY", route: "/utica" },
    { name: "Quick passport services in Albany, NY", route: "/albany-ny" },
    { name: "Urgent passport services in Schenectady, NY", route: "/schenectady" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Rome via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Rome residents can ship from any UPS Store, FedEx Office, or post office location across Oneida County.",
  fpcOfficeDistance: "Serving Rome, Utica, New Hartford, Whitesboro, and all Oneida County and Mohawk Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Rome and all of Oneida County. From Griffiss International Airport to Fort Stanwix, from the Erie Canal to the Mohawk Valley, from Utica to New Hartford — we serve central New York with the same fast, reliable processing. Our courier service eliminates the need to drive 240 miles to Manhattan for passport processing.",
  nearbyCitiesIntro: "We serve Rome and all Oneida County communities including Utica, New Hartford, Whitesboro, Yorkville, Marcy, and Sherrill. We also serve Griffiss International Airport personnel, Rome Lab contractors, and Mohawk Valley travelers departing from SYR and ALB.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Rome as simple as possible — with the efficiency and reliability Mohawk Valley travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Rome travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Rome travelers encounter unique passport issues — everything from Griffiss aviation contractor travel to Erie Canal heritage tours. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Rome travelers — from Griffiss aviation professionals to Fort Stanwix visitors to Oneida County families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Rome, NY? Here are the most common ones we hear from Oneida County and Mohawk Valley travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you're a Griffiss contractor heading to a defense conference, an Erie Canal heritage traveler planning a European canal tour, or a Oneida County family booking a first international trip — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Griffiss contractor heading to a defense conference in three days? SYR flight to Europe this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Rome-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Rome residents renew fast — no agency visit required for most renewals. Perfect for Oneida County professionals, defense contractors, and Mohawk Valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Rome residents through every step — from Griffiss Park to downtown to New Hartford — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your SYR departure or ALB international connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Mohawk Valley family vacation or first international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Oneida County professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Rome Lab researchers, Griffiss aviation contractors, and Mohawk Valley business owners who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Oneida County travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Mohawk Valley travelers heading to Canada via the Thousand Islands Bridge crossing.",
      bullets: ["Wallet-size convenience", "Land and sea travel to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Rome NY", description: "Urgent passport processing for Rome NY travelers with immediate departure needs from Syracuse Hancock or Albany International." },
    { name: "Expedited Passport Renewal Rome NY", description: "Fast passport renewal for Rome NY residents with a previously-issued passport." },
    { name: "First-Time Passport Rome NY", description: "New passport application services for Rome NY residents applying for their first passport." },
    { name: "Child Passport Rome NY", description: "Minor passport services for Rome NY families with children under 16." },
    { name: "Name Change Passport Rome NY", description: "Passport name correction after marriage, divorce, or legal name changes for Rome residents." },
    { name: "Second Passport Rome NY", description: "Second passport services for Rome defense contractors and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Robert K.",
      location: "Rome, NY",
      rating: 5,
      text: "Defense contractor at Griffiss — got called to a conference in Germany with 8 days' notice. Fast Passport Center renewed my passport in 4 days. The dedicated agent understood government contractor travel requirements perfectly.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia M.",
      location: "New Hartford, NY",
      rating: 5,
      text: "First-time passport for my daughter's school trip to France. The agent walked us through the acceptance clerk process at the Rome Post Office. Processed in 5 days — met the school deadline with a week to spare.",
      service: "New Passport",
    },
    {
      name: "James T.",
      location: "Whitesboro, NY",
      rating: 5,
      text: "Erie Canal history buff planning a European canal tour. Lost my passport during the move and Fast Passport Center handled the replacement in 4 days. Now I can compare the old Erie Canal locks to the French canal system in person.",
      service: "Lost Passport Replacement",
    },
    {
      name: "The Anderson Family",
      location: "Rome, NY",
      rating: 5,
      text: "Family reunion in Italy — three passports to renew and only 3 weeks before departure. Fast Passport Center coordinated all three renewals simultaneously. All arrived within 5 days. The Fort Stanwix neighborhood recommends them to everyone.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "rome-1",
      name: "Rome Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "262 W Dominick Street",
      city: "Rome",
      state: "NY",
      zip: "13440",
      phone: "(315) 336-1070",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Downtown Rome",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Major Rome passport acceptance facility. Passport photos available on-site. Busiest facility in Oneida County — book early during summer travel season and around Griffiss contract cycles.",
      icon: "ri-mail-line",
    },
    {
      id: "rome-2",
      name: "New Hartford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "49 Genesee Street",
      city: "New Hartford",
      state: "NY",
      zip: "13413",
      phone: "(315) 733-7161",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "New Hartford — southeast of Rome",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves New Hartford, Washington Mills, and southeast Rome residents. Less crowded than Rome Main. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "rome-3",
      name: "Utica Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Park Avenue",
      city: "Utica",
      state: "NY",
      zip: "13501",
      phone: "(315) 735-6620",
      hours: "Mon–Fri 8:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Utica — ~15 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the Utica-Rome metro area. More appointment slots than Rome or New Hartford. Serves eastern Oneida County and Mohawk Valley communities.",
      icon: "ri-mail-line",
    },
    {
      id: "rome-4",
      name: "Whitesboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 Main Street",
      city: "Whitesboro",
      state: "NY",
      zip: "13492",
      phone: "(315) 736-1867",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Whitesboro — ~5 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Whitesboro, Yorkville, and southern Rome residents. Small facility with limited appointment slots — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "rome-5",
      name: "Oneida County Clerk — Utica",
      type: "County Clerk Passport Acceptance",
      address: "800 Park Avenue",
      city: "Utica",
      state: "NY",
      zip: "13501",
      phone: "(315) 798-5776",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Utica — Oneida County seat",
      website: "https://ocgov.net/oneida/countyclerk",
      websiteLabel: "Oneida County Clerk",
      notes: "Oneida County Clerk passport acceptance. Convenient for county seat business. No photo services on-site — bring compliant photos. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "rome-6",
      name: "Griffiss International Airport — Aviation Resource Center",
      type: "Aviation Hub Passport Resource",
      address: "706 Hangar Road, Griffiss Business & Technology Park",
      city: "Rome",
      state: "NY",
      zip: "13441",
      phone: "(315) 356-2000",
      hours: "Mon–Fri 8:00 AM – 4:30 PM",
      distance: "Griffiss International Airport — Rome",
      website: "https://www.ocgov.net/aviation",
      websiteLabel: "Griffiss International Airport",
      notes: "Griffiss International Airport serves as Oneida County's aviation hub. Aviation contractors and technology park employees can coordinate passport processing with Fast Passport Center from the Griffiss campus.",
      icon: "ri-flight-takeoff-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to New York Passport Agency in Manhattan (~240 miles from Rome)", fpc: "Most Rome travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Central NY & Defense Sector Guidance", agency: "None — no SYR, Griffiss, or defense contractor expertise", fpc: "Full SYR/ALB dual-airport and Griffiss defense/aviation knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Griffiss (RME) Handles Commercial International Flights",
      description: "Griffiss International Airport is primarily an aviation technology, drone testing, and general aviation hub — it does not have scheduled commercial international service. Rome travelers must use SYR or ALB for international departures.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Rome applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Defense Contractor Security Clearance & Passport Confusion",
      description: "Griffiss contractors sometimes confuse security clearance requirements with passport requirements. A security clearance is NOT a passport. Even cleared personnel need a valid U.S. passport for international travel.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Retailers",
      description: "Many Oneida County pharmacies and big-box stores produce photos that fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Waiting Too Long During Winter Season",
      description: "Central New York winter weather can delay overnight shipping by 1–2 days. Rome travelers with winter international departures should add buffer days to their passport timeline.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, Griffiss office, or anywhere in Oneida County." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Rome clients ship from home or the local post office — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 240 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Rome?", a: "We offer Rome-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Rome office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Rome Post Office, New Hartford Post Office, or Oneida County Clerk), then ship documents overnight to our processing center." },
    { q: "Where can I get a passport acceptance in Rome?", a: "Rome has the Main Post Office (262 W Dominick Street), plus facilities in New Hartford, Utica, Whitesboro, and the Oneida County Clerk in Utica. We maintain an updated list of Mohawk Valley facilities." },
    { q: "Can I fly internationally from Griffiss International Airport?", a: "Griffiss (RME) is primarily an aviation technology, drone testing, and general aviation hub — it does not have scheduled commercial international service. Rome travelers use Syracuse Hancock (SYR, 50 miles) or Albany International (ALB, 95 miles) for commercial international flights." },
    { q: "What is the best price for expedited passport service in Rome?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "Can I get a passport photo in Rome?", a: "Yes — CVS Pharmacy, Walgreens, and Walmart offer passport photos in Rome and Utica. Photos must be 2x2 inches, white background, no glasses, neutral expression. We verify photo compliance before submission." },
    { q: "What about defense contractors at Griffiss?", a: "Rome Lab (AFRL) and Griffiss defense contractors travel internationally for conferences, supplier audits, and technology exchanges — often on 1–3 week notice. Our expedited courier service is designed for these short-notice defense sector travel requirements." },
    { q: "How do I check my Rome passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov." },
    { q: "Is there a passport agency closer than Manhattan for Rome residents?", a: "The nearest regional passport agency is in Manhattan (~240 miles). There was previously a Buffalo Passport Agency but it closed. For most Rome travelers, our registered courier service is far more practical than driving 4+ hours to NYC." },
    { q: "Can you help with passports for Erie Canal heritage tours?", a: "Yes — many Rome residents travel to European canal systems (France, Netherlands, UK) inspired by the Erie Canal. We expedite passports for heritage travelers, history buffs, and canal enthusiasts throughout the Mohawk Valley." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Rome Residents",
    intro: "Rome's position in the Mohawk Valley — with Griffiss International Airport, the Erie Canal corridor, and proximity to SYR and ALB — creates distinct passport timing dynamics. Here's what Rome travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "SYR — Syracuse Hancock International Airport",
        subtitle: "Central New York's international gateway, ~50 miles from Rome",
        description: "Syracuse Hancock International Airport is the primary commercial departure point for Rome and Oneida County travelers, with flights to major U.S. hubs and seasonal international service. The 50-mile drive on I-90 takes about 50 minutes — convenient for most departures but far enough that a passport issue at the check-in counter means a wasted trip. SYR serves as the international lifeline for the entire Mohawk Valley.",
        tip: "SYR's international check-in counters close 60 minutes before departure. The drive from Rome to SYR leaves no room for a round trip if your passport has expired. Verify passport validity before leaving Oneida County.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "RME — Griffiss International Airport",
        subtitle: "Former Strategic Air Command base — now a drone testing and aviation technology hub",
        description: "Griffiss International Airport is Rome's greatest aviation asset — a 3,700-acre former Air Force base transformed into an aviation technology park, drone testing corridor, and general aviation center. While Griffiss does not have scheduled commercial passenger service, it anchors Oneida County's defense and aviation economy. Rome Lab (AFRL), drone manufacturers, and aviation contractors based at Griffiss travel internationally for testing, conferences, and supplier relationships.",
        tip: "Griffiss-based aviation professionals should maintain passports with at least 12 months of validity. International testing opportunities and defense conferences often arise with 2–4 weeks notice — standard processing timelines cannot accommodate this.",
      },
      {
        icon: "ri-building-4-line",
        title: "Rome Lab & Defense Contractor Travel",
        subtitle: "Air Force Research Laboratory (AFRL) — Rome Lab at Griffiss",
        description: "Rome Lab (AFRL/RI) is one of the premier Air Force research facilities in the country, specializing in command, control, communications, computers, and intelligence (C4I) technologies. The lab and its network of defense contractors generate consistent international travel demand — researchers presenting at NATO conferences, engineers auditing international suppliers, and program managers coordinating with allied defense organizations. Defense travel often has the shortest lead times of any sector.",
        tip: "Defense contractors with security clearances sometimes assume their clearance documentation replaces a passport for international travel. It does not. A valid U.S. passport is required for all international air travel regardless of security clearance status.",
      },
      {
        icon: "ri-anchor-line",
        title: "Erie Canal Heritage & International Canal Tourism",
        subtitle: "Fort Stanwix and the Erie Canal's eastern gateway",
        description: "Rome sits at a pivotal point on the Erie Canal — the historic waterway that transformed New York and the nation. Fort Stanwix National Monument marks the portage between the Mohawk River and Wood Creek that made Rome strategically important for centuries. This canal heritage creates a unique tourism profile: Rome residents and Erie Canal enthusiasts travel to European canal systems (France, Netherlands, UK) to compare engineering, lock systems, and canal culture.",
        tip: "European canal tour bookings often require advance reservations for boat rentals and lock passage permits. Rome canal travelers should ensure their passport is valid before booking these non-refundable reservations.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The Griffiss Aviation Paradox — No Commercial Flights, Outsized International Travel",
      description: "Griffiss International Airport does not operate scheduled commercial passenger flights, yet it generates some of the most urgent passport demand in Central New York. The aviation technology park's professionals travel internationally on short notice — but must depart from SYR or ALB. The disconnect between where they work and where they fly creates a persistent passport readiness challenge for Rome's defense sector.",
    },
  },
  destinations: {
    title: "Where Rome Travelers Go — And Why Passports Get Urgent",
    intro: "Rome's defense, aviation, and Erie Canal heritage create a unique international travel profile. Here's what drives passport urgency from the Copper City.",
    stats: [
      { stat: "35%", label: "of Rome expedited requests are defense, aviation, or technology contractor-related" },
      { stat: "1–3 Weeks", label: "typical notice for Griffiss contractor international travel — the shortest lead time in Central NY" },
      { stat: "Apr–Oct", label: "peak season when defense conferences, canal tourism, and summer family travel overlap" },
      { stat: "30 Hours", label: "shortest turnaround we have accommodated for a Griffiss contractor departing to Germany" },
    ],
    destinations: [
      { name: "Germany & Central Europe", context: "NATO and defense industry conferences, Griffiss aviation supplier relationships, engineering exchanges", urgency: "Defense conferences with 1–3 week notice — tightest timelines in Central NY", icon: "ri-map-pin-2-line" },
      { name: "France & Netherlands", context: "Erie Canal heritage travelers comparing French and Dutch canal systems, European waterway tourism", urgency: "Canal boat rental reservations booked months ahead with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "UK canal system tourism, British-American heritage, defense industry collaboration", urgency: "Spring and summer canal season — narrowboat bookings require advance planning", icon: "ri-map-pin-2-line" },
      { name: "Italy & Mediterranean", context: "Italian-American heritage in Rome and Utica, family reunions, culinary tourism", urgency: "Family events and reunions with 2–3 week notice", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Rome Lab technology exchanges, Griffiss drone industry collaborations, defense partnerships", urgency: "Official travel orders with 2–4 week windows", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal and Toronto weekend trips, Ottawa business travel, Thousand Islands border crossing", urgency: "Cross-border road trips booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Central New York Service Areas",
    crossLinksDesc: "We serve travelers across Central New York with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Syracuse", route: "/syracuse" },
      { name: "Utica", route: "/utica" },
      { name: "Schenectady", route: "/schenectady" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Rome", address: "1725 Black River Boulevard, Rome, NY 13440", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Rome", address: "410 W Dominick Street, Rome, NY 13440", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Rome", address: "5815 Rome-Taberg Road, Rome, NY 13440", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "The UPS Store — New Hartford", address: "4653 Commercial Drive, New Hartford, NY 13413", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Utica", address: "1904 Genesee Street, Utica, NY 13502", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — New Hartford", address: "50 Kellogg Road, New Hartford, NY 13413", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "FedEx Office — Syracuse", address: "125 Marshall Street, Syracuse, NY 13210", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart Photo Center — Utica", address: "4765 Commercial Drive, New Hartford, NY 13413", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Rome",
      address: "1836 Black River Boulevard, Rome, NY 13440",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Utica",
      address: "321 Main Street, Utica, NY 13501",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Full-service DMV office for Oneida County. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "About 50 miles from Rome",
      address: "1000 Col Eileen Collins Boulevard, Syracuse, NY 13212",
      note: "Central New York's primary airport with flights to major U.S. hubs and international connections. Primary departure point for Rome and Mohawk Valley travelers.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport Website",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 95 miles from Rome",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with domestic and international flights. Alternative for Rome travelers — especially for destinations not served from SYR.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: false,
    },
    {
      code: "RME",
      name: "Griffiss International Airport",
      distance: "In Rome, NY",
      address: "706 Hangar Road, Rome, NY 13441",
      note: "Former Strategic Air Command base — now an aviation technology park, drone testing hub, and general aviation facility. No scheduled commercial passenger service. Home to Rome Lab (AFRL) and Griffiss Business & Technology Park.",
      flightUrl: "https://www.ocgov.net/aviation",
      flightLabel: "Griffiss Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Online, mail, or in-person options available for Oneida County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Required for estate and legal matters in Oneida County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Oneida County Clerk in Utica. Certified copies available for name changes and legal purposes.",
      url: "https://ocgov.net/oneida/countyclerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Oneida County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default romeNyConfig;